export default abstract class GenericEntity {
    _id!: string;
}

export class Wrapper<T> {
    count!: number;
    items!: T[];
}